import { dashboardIcons, dashboardIconColors, type DashboardIconKey } from '../Icons'

interface IconPickerProps {
  value: string | undefined
  onChange: (key: DashboardIconKey) => void
  color?: string
}

const iconKeys = Object.keys(dashboardIcons) as DashboardIconKey[]

export const IconPicker = ({ value, onChange, color }: IconPickerProps) => {
  const colorClass = color ? (dashboardIconColors as Record<string, string>)[color] : undefined

  return (
    <div
      role="radiogroup"
      aria-label="Dashboard icon"
      className="grid grid-cols-[repeat(auto-fill,minmax(2.5rem,1fr))] gap-2"
    >
      {iconKeys.map((key) => {
        const Icon = dashboardIcons[key]
        const selected = value === key
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={key}
            title={key}
            onClick={() => onChange(key)}
            className={`flex h-10 items-center justify-center rounded-lg border
  transition-colors ${
    selected ? 'border-primary bg-primary text-primary-content' : 'border-base-300 hover:bg-base-200'
  }`}
          >
            <Icon size={20} className={selected ? undefined : colorClass} />
          </button>
        )
      })}
    </div>
  )
}
